<template>
  <div class="root-container">
    <el-form ref="registerRef" label-width="150px" size="small" :model="cardInfo">
      <el-row>
        <el-col :span="12">
          <el-form-item label="选择:">
            <el-radio v-model="radio" :label="1">停卡</el-radio>
            <el-radio v-model="radio" :label="2">开卡</el-radio>
          </el-form-item>
        </el-col>
        <el-col :span="12"></el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="会员姓名:" prop="childName">
            <el-input
              readonly="true"
              style="width: 270px"
              v-model="cardInfo.childName"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机号:" prop="userPhone">
            <el-input
              readonly="true"
              style="width: 270px"
              v-model="cardInfo.userPhone"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="卡ID:" prop="id">
            <el-input
              readonly="true"
              style="width: 270px"
              v-model="cardInfo.id"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="卡名称:" prop="cardName">
            <el-input
              readonly="true"
              style="width: 270px"
              v-model="cardInfo.cardName"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="金额:" prop="totalPay">
            <el-input
              readonly="true"
              style="width: 270px"
              v-model="cardInfo.totalPay"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="正价课时:" prop="totalLesssonCount">
            <el-input
              readonly="true"
              style="width: 270px"
              v-model="cardInfo.totalLesssonCount"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="赠送课时:" prop="totalGiveCount">
            <el-input
              readonly="true"
              style="width: 270px"
              v-model="cardInfo.totalGiveCount"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="剩余正价课时:" prop="remainingClass">
            <el-input
              readonly="true"
              style="width: 270px"
              v-model="cardInfo.remainingClass"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="当前有效期:">
            <el-input
              readonly="true"
              style="width: 270px"
              v-model="cardInfo.cardEndTime"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="剩余赠送课时:" prop="remainingGiveCount">
            <el-input
              readonly="true"
              style="width: 270px"
              v-model="cardInfo.remainingGiveCount"
              placeholder=""
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="设置停卡日期范围:" v-show="radio === 1">
        <el-date-picker
          style="width: 714px"
          v-model="cardInfo.stopCardDate"
          type="daterange"
          range-separator="~"
          start-placeholder="开始"
          end-placeholder="结束"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="备注:">
        <el-input v-model="cardInfo.remark"
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入内容"
          style="width: 714px"
        ></el-input>
      </el-form-item>

      <!-- <el-form-item label="卡类型:" >
          <el-input  readonly="true" style="width: 240px;"  v-model="cardInfo.cardName" placeholder=""></el-input>
        </el-form-item> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleStopCard('registerRef')"
        >保存</el-button
      >
    </span>
  </div>
</template>

<script>
export default {
  props: {
    cardInfo: Object,
  },
  data() {
    return {
      radio: 1,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {},
    handleCancel() {
      this.$emit("onBtnCancel");
    },
    handleStopCard(registerRef) {
      this.$refs[registerRef].validate((valid) => {
        if (valid) {
          let params = {
            radio: this.radio,
            stopCardDate:this.cardInfo.stopCardDate,
            remark:this.cardInfo.remark
          };
          console.log(params,'params')
          this.$emit("onBtnCreate", params);
          //   let param = this.createParam;
          //   param.storeFrontId = globaldata.getAdminStore().storeFrontId;
          //   param.createAdminId = globaldata.getAdminStore().id;
          //   createUserChild(param).then((response) => {
          //     messageUtils.successMsg(this, "创建成功");
          //     this.$emit("onBtnCreate");
          //   });
        } else {
          return false;
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/user-by-lesson-card/components/warningAddCard.vue